import { PayrollProvider } from '../graphql';
import { FeatureFlags } from '../third-parties';

export const PAYROLL_PROVIDER_NAMES: Record<PayrollProvider, string> = {
  ADP_RUN: 'RunADP',
  ADP_WORKFORCE_NOW: 'ADP Workforce Now',
  CERIDIAN_DAYFORCE: 'Dayforce',
  GUSTO: 'Gusto',
  JUSTWORKS: 'Justworks',
  PAYCHEX_FLEX: 'Paychex Flex',
  PAYLOCITY: 'Paylocity',
  QUICKBOOKS: 'QuickBooks Payroll',
  RIPPLING: 'Rippling',
  SELF_REPORTED: 'Payroll CSV Upload',
  TRINET: 'TriNet',
  WORKDAY: 'Workday',
  ZENEFITS: 'Zenefits',
};

export const PAYROLL_PROVIDER_FLAGS: Record<PayrollProvider, keyof FeatureFlags> = {
  ADP_RUN: 'enableAdpRun',
  ADP_WORKFORCE_NOW: 'enableAdpWorkforceNow',
  CERIDIAN_DAYFORCE: 'enableCeridianDayforce',
  GUSTO: 'enableGusto',
  JUSTWORKS: 'enableJustworks',
  PAYCHEX_FLEX: 'enablePaychexFlex',
  PAYLOCITY: 'enablePaylocity',
  QUICKBOOKS: 'enableQuickbooksPayroll',
  RIPPLING: 'enableRippling',
  SELF_REPORTED: 'enablePayrollCsvUpload',
  TRINET: 'enableTrinet',
  WORKDAY: 'enableWorkday',
  ZENEFITS: 'enableZenefits',
};
